import type { ReactNode } from 'react';
import { HeaderIcons } from './icons';

export type PlayerHeaderLeftButton = {
  icon: ReactNode;
  onClick: () => void;
  tooltip: string;
};

/**
 * Left header button for player screens.
 * Host-as-player: Back → game selection. Regular players: Home → leave.
 */
export function getPlayerHeaderLeftButton(options: {
  isHost?: boolean;
  onBackToGameSelection?: () => void;
  onGoHome?: () => void;
  backTooltip: string;
  homeTooltip: string;
}): PlayerHeaderLeftButton | undefined {
  const { isHost, onBackToGameSelection, onGoHome, backTooltip, homeTooltip } = options;
  if (isHost && onBackToGameSelection) {
    return {
      icon: HeaderIcons.back,
      onClick: onBackToGameSelection,
      tooltip: backTooltip,
    };
  }
  if (onGoHome) {
    return {
      icon: HeaderIcons.home,
      onClick: onGoHome,
      tooltip: homeTooltip,
    };
  }
  return undefined;
}
